// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-c041d754] {\n  font-size: 16px;\n  font-weight: bold;\n  color: black;\n}\n.tip-container[data-v-c041d754] {\n  font-size: 14px;\n  line-height: 30px;\n}\n[data-v-c041d754] .el-dialog__body {\n  padding: 10px 20px 20px;\n  border-top: 1px solid #D7D7D7;\n}\n", ""]);
// Exports
module.exports = exports;
